export default __webpack_public_path__ + "static/media/earn.bceaf2d1.png";